// Shared icon size constants used across components.
// Centralised here to avoid magic numbers in JSX.

export const PROCESS_ICON_SIZE = 26;
export const VALUE_ICON_SIZE = 26;
export const EXPERTISE_CHECK_ICON_SIZE = 22;
export const FAQ_CHEVRON_SIZE = 22;
export const TRUST_BADGE_ICON_SIZE = 42;
